/**
 * Storage seam for the client-side batched usage counter (CSW-1643).
 *
 * v1 ships only `InMemoryUsageCounterStorage` — losing an unflushed remainder
 * on tab-kill is an acceptable rounding error for a usage counter, so
 * durability isn't required yet. This interface exists so a `localStorage`
 * (or IndexedDB) backed implementation can be dropped in later, purely by
 * providing `CAPICHE_USAGE_COUNTER_STORAGE`, with zero changes to
 * UsageCounterService.
 */
export interface UsageCounterStorage {
  load(): number;
  save(count: number): void;
  clear(): void;
}

/** Default storage: in-memory only, scoped to the current page session. */
export class InMemoryUsageCounterStorage implements UsageCounterStorage {
  private count = 0;

  load(): number {
    return this.count;
  }

  save(count: number): void {
    this.count = count;
  }

  clear(): void {
    this.count = 0;
  }
}
